module.exports = __webpack_public_path__ + "static/assets/33b737193edfe1730f38112ad35a84b4.svg";